<app-attendee-reviews-page [hasOrganizer]="true"></app-attendee-reviews-page>
